const commonHi = {
    common: require('../../lang/hi/common/Common').default,
};

export default commonHi;